'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * The schema change type.
 * Raw type: Initial type that contains both global and local vertex and edge types.
 * Global: Global schema change job.
 * Local: Local schema change job.
 *
 * @export
 * @enum {number}
 */
var SchemaChangeType = /*#__PURE__*/function (SchemaChangeType) {
  SchemaChangeType["Raw"] = "raw";
  SchemaChangeType["Global"] = "global";
  SchemaChangeType["Local"] = "local";
  return SchemaChangeType;
}({});

/**
 * Altering one vertex or edge type.
 * Supported changes:
 * (1. Rename the vertex or edge (not supported in GSQL yet))
 * 2. Drop attributes.
 * 3. Add new attributes.
 *
 * @export
 * @interface AlterVertexOrEdge
 */

/**
 * Schema change contains three sections:
 * 1. Alter edge types.
 * 2. Alter vertex types.
 * 3. Drop old edge types.
 * 4. Drop old vertex types.
 * 5. Add new vertex types.
 * 6. Add new edge types.
 * The sections follow the above order. Here we assume if we alter a vertex or edge type,
 * it won't be dropped (otherwise it should only appear in dropping list, not in altering list)
 *
 * @export
 * @interface SchemaChange
 */

exports.SchemaChangeType = SchemaChangeType;
